import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Principle {
  title: string;
  icon: string;
  items: string[];
}

@Component({
  selector: 'app-principles',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './principles.component.html',
  styleUrl: './principles.component.scss',
})
export class PrinciplesComponent {
  principles: Principle[] = [
    {
      title: 'Domain Principles',
      icon: 'domain',
      items: [
        'Holistic development of Agri related ecosystems',
        'Encouraging ecosystem play with wider stakeholder participation',
        'Impact oriented design for measuring environmental, social and economic impacts',
        'National footprint that enables seamless coordination across the states'
      ]
    },
    {
      title: 'Technology Principles',
      icon: 'technology',
      items: [
        'Adoption of a federated and decentralised architecture',
        'Conform to open standards, interoperability, and reuseability',
        'Open API-based ecosystem',
        'Ensure security and privacy by design'
      ]
    },
    {
      title: 'Governance Principles',
      icon: 'governance',
      items: [
        'Enabling policies and governance framework',
        'Clear and accountable institutional mechanism',
        'Inclusiveness and universal access',
        'Well-defined safeguard and security policy'
      ]
    }
  ];
}

